import React from "react";
import "../styles/Contacto.css";

const Contacto = () => {
  return (
    <div className="presentation-page pt-16">
      {/* Hero Section */}
      <header className="contacto-hero-section">
        <div className="contacto-hero-content">
          <div className="contacto-hero-container">
            <div className="contacto-hero-card">
              <div className="contacto-hero-grid">
                <div className="contacto-hero-left">
                  <h1 className="contacto-hero-title">
                    Ponte en <span className="contacto-hero-title-gradient">Contacto</span>
                  </h1>
                </div>
                <div className="contacto-hero-right">
                  <p className="contacto-hero-description">
                    Estamos aquí para responder tus preguntas y recibir tus comentarios sobre la Red Sísmica del Noroeste de México y nuestra página web.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Contacto Section */}
      <section className="contacto-content-section">
        <div className="contacto-content-container">
          <div className="contacto-intro">
            <h2 className="contacto-section-title">
              Personas de <span className="contacto-section-title-gradient">Contacto</span>
            </h2>
            <p className="contacto-section-description">
              Conoce a los responsables de la RESNOM y cómo puedes comunicarte con ellos.
            </p>
          </div>

          {/* Contact Cards Grid */}
          <div className="contacto-cards-grid">
            {/* Card 1: Coordinador */}
            <div className="contacto-card">
              <div className="contacto-card-header">
                <div className="contacto-card-icon">
                  <i className="fas fa-user-tie"></i>
                </div>
                <h3 className="contacto-card-role">Coordinador de la Red</h3>
              </div>

              <div className="contacto-card-body">
                <h4 className="contacto-card-name">Dr. Oscar Alberto Castro Artola</h4>

                <div className="contacto-card-contact">
                  <div className="contacto-contact-item">
                    <i className="fas fa-envelope"></i>
                    <a href="mailto:oscar.castro@cicese.mx">oscar.castro@cicese.mx</a>
                  </div>
                </div>

                <p className="contacto-card-description">
                  Responsable de la coordinación general y operación de la Red Sísmica del Noroeste de México (RESNOM).
                </p>
              </div>
            </div>

            {/* Card 2: Comentarios Web */}
            <div className="contacto-card">
              <div className="contacto-card-header">
                <div className="contacto-card-icon">
                  <i className="fas fa-comments"></i>
                </div>
                <h3 className="contacto-card-role">Comentarios y Sugerencias</h3>
              </div>

              <div className="contacto-card-body">
                <h4 className="contacto-card-name">M.C. Ma. Alejandra Núñez Leal</h4>

                <div className="contacto-card-contact">
                  <div className="contacto-contact-item">
                    <i className="fas fa-envelope"></i>
                    <a href="mailto:anunez@cicese.mx">anunez@cicese.mx</a>
                  </div>
                </div>

                <p className="contacto-card-description">
                  Encargada de recibir comentarios, sugerencias y reporte de problemas sobre nuestra página web.
                </p>
              </div>
            </div>
          </div>

          {/* Additional Info Section */}
          <div className="contacto-additional-info">
            <div className="contacto-info-card">
              <div className="contacto-info-icon">
                <i className="fas fa-building"></i>
              </div>
              <div className="contacto-info-content">
                <h4 className="contacto-info-title">CICESE</h4>
                <p className="contacto-info-text">
                  Centro de Investigación Científica y de Educación Superior de Ensenada
                </p>
              </div>
            </div>

            <div className="contacto-info-card">
              <div className="contacto-info-icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <div className="contacto-info-content">
                <h4 className="contacto-info-title">Ubicación</h4>
                <p className="contacto-info-text">
                  Ensenada, Baja California, México
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contacto;
